const state = {
    routerArray: [],
    basic: '',
    metaName: ''
}
const mutations = {
    setRouterInfo(state, newArray) {
        state.routerArray = newArray
    },
    setBasic(state, basic) {
        state.basic = basic
    },
    setMetaName(state, metaName) {
        state.metaName = metaName
    },
}
const actions = {
    setRouter({ commit }, value) {
        let newArray = []
        let basic = ''
        let { basicName, basicRoute, basicTitle } = value
        basicRoute.forEach((element, index1) => {
            if (element.children) {
                element.children.forEach((item, index) => {
                    if (item && item.meta.basicName === basicName) {
                        basic = item.meta.basic
                        newArray.push(item);
                        // if (get('userData').parentId == '0') {
                        //     newArray.push(item);
                        // } else {
                        //     if (!item.meta.isparent) {
                        //         newArray.push(item);
                        //     }
                        // }
                    }
                });
            }
        });
        commit('setRouterInfo', newArray)
        commit('setBasic', basic)
        commit('setMetaName', basicTitle)
    }
}
export default {
    namespaced: true,
    state,
    mutations,
    actions,
};